// extracted by mini-css-extract-plugin
export var alignBaseline = "_1-9";
export var alignCenter = "_1-5";
export var alignFlexEnd = "_1-7";
export var alignFlexStart = "_1-6";
export var alignSelfBaseline = "_1-e";
export var alignSelfCenter = "_1-a";
export var alignSelfFlexEnd = "_1-c";
export var alignSelfFlexStart = "_1-b";
export var alignSelfStretch = "_1-d";
export var alignStretch = "_1-8";
export var column = "_1-2";
export var columnReverse = "_1-4";
export var flex = "_1-0";
export var justifyCenter = "_1-f";
export var justifyFlexEnd = "_1-h";
export var justifyFlexStart = "_1-g";
export var justifySpaceAround = "_1-j";
export var justifySpaceBetween = "_1-i";
export var justifySpaceEvenly = "_1-k";
export var row = "_1-1";
export var rowReverse = "_1-3";
export var wrapNowrap = "_1-m";
export var wrapWrap = "_1-l";
export var wrapWrapReverse = "_1-n";